module.exports = __webpack_public_path__ + "static/img/strona_042.6dee9446.jpg";